import gql from 'graphql-tag';

export default gql`
  query analyzeSmartCart($input: AnalyzeSmartCartInput!) {
    analyzeSmartCart(input: $input) {
      items {
        inputText
        matchedProduct {
          productId
          sku
          name
          unit
          price
          imageUrl
          quantity
          uom
          uomLocal
          netUom
          baseUom
          baseUnit
          netUnit
        }
        confidence
        confidenceScore
        fromHistory
        alternatives {
          productId
          sku
          name
          unit
          price
          imageUrl
          quantity
          uom
          uomLocal
          netUom
          baseUom
          baseUnit
          netUnit
        }
      }
      summary {
        total
        matched
        unmatched
      }
    }
  }
`;
